var _clipPath, _clipPath2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlerryLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.129756,0.969971)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Small-Cherry",
    serifId: "Small Cherry",
    transform: "matrix(0.0838387,0,0,0.0838387,-34.6898,-5.53358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kirsche",
    transform: "matrix(1,0,0,1,0.100062,0.386195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.572,309.482C495.052,308.521 463.829,298.448 448.692,307.158C423.592,321.6 413.654,351.723 413.32,378.786C413.088,397.663 419.059,414.051 428.66,430.113C445.109,457.634 467.846,480.056 501.51,482.982C515.805,484.224 523.594,481.909 537.468,479.235C547.821,477.24 550.47,477.318 560.182,471.867C575.825,463.088 583.017,450.103 590.76,434.454C601.111,413.536 600.797,413.432 605.844,390.728C609.272,375.302 606.87,360.685 603.37,345.484C602.251,340.62 599.895,333.101 596.537,329.165C586.708,317.645 567.876,303.928 551.53,306.634C542.268,308.168 537.821,308.719 528.326,309.571C522.515,310.093 515.701,310.583 510.058,310.103L506.572,309.482Z",
    style: {
      fill: "url(#_Radial1)",
      stroke: "rgb(233,236,239)",
      strokeWidth: "2.39px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ende-Stiehl",
    serifId: "Ende Stiehl",
    d: "M613.5,94.065C618.81,99.591 627.402,102.227 634.706,99.587C639.353,97.908 644.322,94.095 647.693,90.579C649.073,89.14 650.272,87.528 651.378,85.869C653.883,82.114 658.753,73.733 653.4,69.718C652.039,68.698 650.541,67.807 648.932,67.255C647.202,66.661 645.345,66.491 643.523,66.331C640.228,66.041 634.878,66.533 631.819,67.025C627.666,67.692 624.076,68.301 620.652,70.866C616.636,73.876 613.606,79.903 611.589,83.863L610.946,89.03L613.5,94.065Z",
    style: {
      fill: "rgb(179,182,200)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.2373,218.019,-71.0932)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.55,
    cy: 321.246,
    rx: 17.446,
    ry: 6.811,
    style: {
      fill: "url(#_Radial2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stiehl-stecker",
    serifId: "Stiehl stecker",
    transform: "matrix(1.06912,0,0,1.08644,-35.3008,-27.9897)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.306,
    y: 321.341,
    width: 34.78,
    height: 8.819
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.399,311.812C519.566,288.554 524.067,265.923 528.367,243.171C535.324,206.363 544.678,170.962 565.796,139.551C575.617,124.943 576.741,126.067 589.036,113.417C597.429,104.781 595.766,103.084 605.39,97.629C610.737,94.597 618.869,89.444 624.813,87.822C628.879,86.713 630.933,88.139 631.128,83.035C631.638,69.667 615.339,81.104 611.589,83.863C595.072,96.017 581.058,104.816 569.373,121.079C557.386,137.762 558.186,138.096 548.569,156.377C544.495,164.122 536.801,177.39 533.933,185.741C527.964,203.125 526.07,216.84 522.6,234.804C517.737,259.983 512.717,285.133 507.96,310.332L507.86,310.108C507.736,310.597 508.414,317.976 506.547,320.126C504.984,321.927 498.407,324.689 498.307,327.071C498.243,328.601 502.494,329.403 503.835,329.458C506.56,329.569 518.042,331.697 522.364,327.954C523.557,326.922 519.004,321.578 518.82,320.011C518.379,316.247 520.493,315.813 520.493,312.024L520.399,311.812Z",
    style: {
      fill: "rgb(52,57,69)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Stiehl",
    d: "M520.471,311.698C519.637,288.44 524.067,265.923 528.367,243.171C535.324,206.363 544.678,170.962 565.796,139.551C575.617,124.943 576.741,126.067 589.036,113.417C597.429,104.781 595.766,103.084 605.39,97.629C610.737,94.597 618.869,89.444 624.813,87.822C628.879,86.713 630.933,88.139 631.128,83.035C631.638,69.667 615.339,81.104 611.589,83.863C595.072,96.017 581.058,104.816 569.373,121.079C557.386,137.762 558.186,138.096 548.569,156.377C544.495,164.122 536.801,177.39 533.933,185.741C527.964,203.125 526.07,216.84 522.6,234.804C517.737,259.983 507.96,310.332 507.86,310.108C507.736,310.597 505.199,319.83 503.332,321.98C501.768,323.78 498.407,324.689 498.307,327.071C498.243,328.601 502.494,329.403 503.835,329.458C506.56,329.569 518.042,331.697 522.364,327.954C523.557,326.922 521.367,324.938 521.183,323.371C520.742,319.608 520.493,315.813 520.493,312.024L520.471,311.698Z",
    style: {
      fill: "url(#_Linear4)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Small-Cherry1",
    serifId: "Small Cherry",
    transform: "matrix(-0.0906172,0,0,0.0906172,61.1009,-5.98262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kirsche1",
    serifId: "Kirsche",
    transform: "matrix(1,0,0,1,0.100062,0.386195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.572,309.482C495.052,308.521 463.829,298.448 448.692,307.158C423.592,321.6 413.654,351.723 413.32,378.786C413.088,397.663 419.059,414.051 428.66,430.113C445.109,457.634 467.846,480.056 501.51,482.982C515.805,484.224 523.594,481.909 537.468,479.235C547.821,477.24 550.47,477.318 560.182,471.867C575.825,463.088 583.017,450.103 590.76,434.454C601.111,413.536 600.797,413.432 605.844,390.728C609.272,375.302 606.87,360.685 603.37,345.484C602.251,340.62 599.895,333.101 596.537,329.165C586.708,317.645 567.876,303.928 551.53,306.634C542.268,308.168 537.821,308.719 528.326,309.571C522.515,310.093 515.701,310.583 510.058,310.103L506.572,309.482Z",
    style: {
      fill: "url(#_Radial5)",
      stroke: "rgb(233,236,239)",
      strokeWidth: "2.21px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ende-Stiehl1",
    serifId: "Ende Stiehl",
    d: "M613.5,94.065C618.81,99.591 627.402,102.227 634.706,99.587C639.353,97.908 644.322,94.095 647.693,90.579C649.073,89.14 650.272,87.528 651.378,85.869C653.883,82.114 658.753,73.733 653.4,69.718C652.039,68.698 650.541,67.807 648.932,67.255C647.202,66.661 645.345,66.491 643.523,66.331C640.228,66.041 634.878,66.533 631.819,67.025C627.666,67.692 624.076,68.301 620.652,70.866C616.636,73.876 613.606,79.903 611.589,83.863L610.946,89.03L613.5,94.065Z",
    style: {
      fill: "rgb(179,182,200)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.2373,218.019,-71.0932)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.55,
    cy: 321.246,
    rx: 17.446,
    ry: 6.811,
    style: {
      fill: "url(#_Radial6)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stiehl-stecker1",
    serifId: "Stiehl stecker",
    transform: "matrix(1.06912,0,0,1.08644,-35.3008,-27.9897)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.306,
    y: 321.341,
    width: 34.78,
    height: 8.819
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.399,311.812C519.566,288.554 524.067,265.923 528.367,243.171C535.324,206.363 544.678,170.962 565.796,139.551C575.617,124.943 576.741,126.067 589.036,113.417C597.429,104.781 595.766,103.084 605.39,97.629C610.737,94.597 618.869,89.444 624.813,87.822C628.879,86.713 630.933,88.139 631.128,83.035C631.638,69.667 615.339,81.104 611.589,83.863C595.072,96.017 581.058,104.816 569.373,121.079C557.386,137.762 558.186,138.096 548.569,156.377C544.495,164.122 536.801,177.39 533.933,185.741C527.964,203.125 526.07,216.84 522.6,234.804C517.737,259.983 512.717,285.133 507.96,310.332L507.86,310.108C507.736,310.597 508.414,317.976 506.547,320.126C504.984,321.927 498.407,324.689 498.307,327.071C498.243,328.601 502.494,329.403 503.835,329.458C506.56,329.569 518.042,331.697 522.364,327.954C523.557,326.922 519.004,321.578 518.82,320.011C518.379,316.247 520.493,315.813 520.493,312.024L520.399,311.812Z",
    style: {
      fill: "rgb(52,57,69)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Stiehl1",
    serifId: "Stiehl",
    d: "M520.471,311.698C519.637,288.44 524.067,265.923 528.367,243.171C535.324,206.363 544.678,170.962 565.796,139.551C575.617,124.943 576.741,126.067 589.036,113.417C597.429,104.781 595.766,103.084 605.39,97.629C610.737,94.597 618.869,89.444 624.813,87.822C628.879,86.713 630.933,88.139 631.128,83.035C631.638,69.667 615.339,81.104 611.589,83.863C595.072,96.017 581.058,104.816 569.373,121.079C557.386,137.762 558.186,138.096 548.569,156.377C544.495,164.122 536.801,177.39 533.933,185.741C527.964,203.125 526.07,216.84 522.6,234.804C517.737,259.983 507.96,310.332 507.86,310.108C507.736,310.597 505.199,319.83 503.332,321.98C501.768,323.78 498.407,324.689 498.307,327.071C498.243,328.601 502.494,329.403 503.835,329.458C506.56,329.569 518.042,331.697 522.364,327.954C523.557,326.922 521.367,324.938 521.183,323.371C520.742,319.608 520.493,315.813 520.493,312.024L520.471,311.698Z",
    style: {
      fill: "url(#_Linear8)"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.19394,121.355,-121.355,-5.19394,508.009,332.983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166,212,222)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(141,186,204)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(74,113,155)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(16.0106,-0.543855,0.325072,6.25105,293.045,321.151)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "black",
      stopOpacity: 0.43
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(115.333,-240.297,240.297,115.333,508.958,322.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52,57,69)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(233,236,239)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.19394,121.355,-121.355,-5.19394,508.009,332.983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166,212,222)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(141,186,204)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(74,113,155)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(16.0106,-0.543855,0.325072,6.25105,293.045,321.151)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "black",
      stopOpacity: 0.54
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "black",
      stopOpacity: 0.43
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(115.333,-240.297,240.297,115.333,508.958,322.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52,57,69)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(233,236,239)",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlerryLogo);
export default __webpack_public_path__ + "static/media/blerry_logo.085eb818265dd341be2f63988eeaa1dc.svg";
export { ForwardRef as ReactComponent };